import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { addMonths, subDays } from 'date-fns';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { getDateAsUTC, ToastService } from 'src/app/core';
import {
  CandidateApi, CandidateGridInfo, CandidateProfile, DateRange, Employee,
  FilterParams, HttpStatusCode, KeyValuePairOfStringAndDateTime, LookupApi,
  LookupField,
  MilestonesApi, PBApi,
  PBProfile, RoleType,
  SortParameters, UserApi
} from 'src/app/core/api.gen';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/core/common.service';
import { CSVReportService } from 'src/app/core/csvreport.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoaderService } from 'src/app/core/loader.service';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined } from '../../../app/core/utils';
import { DateFields } from '../../shared/Date-Fields';
import { LookupTypeKeys } from '../../shared/lookup-type-keys';
import { AlertComponent } from '../alert/alert.component';
import { StatusTypes } from '../status-types';
@Component({
  selector: 'eos-candidate-grid',
  templateUrl: './candidate-grid.component.html',
  changeDetection:ChangeDetectionStrategy.OnPush,  
  styleUrls: ['./candidate-grid.component.css']
})
export class CandidateGridComponent implements OnInit, OnChanges {

  // data Models
  @ViewChild('rangePicker') rangePicker;
  @Input() data: CandidateGridInfo;
  @Output() deleteEvent = new EventEmitter<CandidateProfile>();
  @Output() editEvent = new EventEmitter<CandidateProfile>();
  @Output() editOnTask = new EventEmitter<CandidateProfile>();
  // @Output() statusEvent = new EventEmitter<CandidateStatusCount[]>();
  @Output() filterEvent = new EventEmitter<SortParameters>();

  serviceLines: LookupField[] = [];
  officeLocations: LookupField[] = [];
  recruiters: Employee[] = [];
  ptcs: Employee[] = [];
  pbStatuses: LookupField[] = [];
  startDates: KeyValuePairOfStringAndDateTime[] = [];
  startDateStatuses: LookupField[] = [];
  subServiceLines: LookupField[] = [];
  profileSubmittedDates: KeyValuePairOfStringAndDateTime[] = [];
  employeeCategories: LookupField[] = [];
  preboardingTypes: LookupField[] = [];
  hireTypes: LookupField[] = [];
  transferTypes: LookupField[] = [];
  immigrationCaseTypes: LookupField[] = [];
  SortParameters: SortParameters;
  // Pagination
  currentPage: number;
  totalRecords: number;
  totalPages: number;
  changeCount: number[] = [10, 15, 25, 50, 75];
  pages: number[] = [];
  tableLoading = true;
  pageNumber = 1;
  isRecruitment = true;
  disableDownload = false;
  disableDownloadVendor = false;
  disableReport = false;
  disableSearch = false;
  disableControl = false;
  selectedServicelines = [];
  selectedOfficeLocations = [];
  selectedRecruiters = [];
  selectedPTCs = [];
  selectedPbStatuses = [];
  selectedStartDates = [];
  selectedStartDateStatuses = [];
  selectedSSLs = [];
  selectedProfSubmittedDates = [];
  selectedEmployeeCategories = [];
  selectedPreboardingTypes = [];
  selectedHireTypes = [];
  selectedTransferTypes = [];
  selectedImmigrationCaseTypes = [];
  dropdownSettings = {};
  datedropdownSettings = {};
  dropdownEmployeeSettings = {};
  daterange: string;
  submissionDateRange: string;
  maxDate = new Date();
  isDateRangeSelected = false;
  mod: string;
  redirectUrl: string;
  candProfile: CandidateProfile;
  pbProfile: PBProfile;
  newstartDate = new Date();
  stDate: Date;
  milstoneDisableStatuses = [1, 2]

  constructor(
    private candidateService: CandidateApi,
    private toast: ToastService,
    private lookUpService: LookupApi,
    private common: CommonService,
    private csvreportService: CSVReportService,
    private authService: AuthService,
    private userAPI: UserApi,
    private modalService: NgbModal,
    private loader: LoaderService,
    private pbAPI: PBApi,
    private datePipe: DatePipe,
    private dialog: DialogService,
    private milestoneAPI: MilestonesApi
  ) {

  }

  bsConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD-MMM-YY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    customTodayClass: 'custom-today-class',
    adaptivePosition: true
  };

  ngOnChanges() {
    this.disableSearch = false;
    if (this.data) {
      forkJoin(
        this.getStartDates(),
        this.getProfileSubmittedDates()
      ).subscribe(f => {
        this.mapBackFilters();
      });
      this.disableReport = this.data.startdatePending;
      this.gridConfigure();
    }
    // if (!isNullOrUndefined(this.data.sortParameters)) {
    //   this.daterange = this.datePipe.transform(this.data.sortParameters.filterParams.startDate, 'dd-MMM-yy') + " - " + this.datePipe.transform(this.data.sortParameters.filterParams.endDate, 'dd-MMM-yy');
    // }

  }

  canViewActivity(statusId): boolean {
    return this.authService.isAuthorised('CanEditActivities-PTC') && this.common.canViewActivityList(statusId);
  }

  canDeleteProfile(statusId: number): boolean {
    return statusId === 1 && this.isRecruitment && this.authService.isAuthorised('CanEdit-RMT');
  }

  canEditStartDate(): boolean {
    return !this.isRecruitment && this.authService.isAuthorised('CanEdit-PTC');
  }

  ngOnInit() {

    this.isRecruitment = this.common.isRecruitment;
    if (this.isRecruitment) {
      this.mod = "RMT";
    } else {
      this.mod = "PTC";
    }
    if (this.authService.isAuthorised(['RMT:required', 'CanDownloadReport-RMT:required'])
      || this.authService.isAuthorised(['CanDownloadReport-PTC:required', 'PTC:required'])) {
      this.disableControl = true;
    }

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'displayText',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.datedropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'key',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.dropdownEmployeeSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.loadFilters();
  }

  private loadFilters() {
    forkJoin(
      this.getSls(),
      this.getLocations(),
      this.getRecruiters(),
      this.getPTCs(),
      this.getPbStatuses(),
      this.getStartDates(),
      this.getStartDateStatuses(),
      this.getSSLs(),
      this.getEmployeeCategories(),
      this.getPreboardingTypes(),
      this.getHireTypes(),
      this.getImmigrationCaseTypes(),
      this.getTransferTypes(),
      this.getProfileSubmittedDates()).subscribe(f => {
        this.mapBackFilters();
      });
  }

  private getSls() {
    const ob$ = this.lookUpService.getServiceLines(undefined, undefined);
    ob$.subscribe(resp => {
      this.serviceLines = resp;
    });
    return ob$;
  }

  onDateRangePickerShow() {
    if (!this.isDateRangeSelected) {
      const currDate = new Date();
      currDate.setMonth(currDate.getMonth());
      this.rangePicker._datepicker.instance.monthSelectHandler({ date: currDate });
    }

  }
  // onValueChange(value: Date) {
  //   if (value !== null) {
  //     if (value[0] !== this.dateRange[0] && value[1] !== this.dateRange[1]) {
  //       this.isDateRangeSelected = true;
  //     }
  //   }
  // }
  getLocations() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.OFFICE_LOCATION, undefined)
    ob$.subscribe(resp => {
      this.officeLocations = resp.lookupFields;
    });
    return ob$;
  }

  getRecruiters() {
    const ob$ = this.userAPI.getEmployeesByRole(RoleType.Recruiter);
    ob$.subscribe(resp => {
      this.recruiters = resp;
    });

    return ob$;
  }
  getEmployeeCategories() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES, undefined)
    ob$.subscribe(resp => {
      this.employeeCategories = resp.lookupFields;
    });
    return ob$;
  }
  getPreboardingTypes() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.ONBOARDING_TYPES, undefined)
    ob$.subscribe(resp => {
      this.preboardingTypes = resp.lookupFields;
    });
    return ob$;
  }
  getHireTypes() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.HIRE_TYPE, undefined)
    ob$.subscribe(resp => {
      this.hireTypes = resp.lookupFields;
    });
    return ob$;
  }
  getTransferTypes() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.TRANSFER_TYPES, undefined)
    ob$.subscribe(resp => {
      this.transferTypes = resp.lookupFields;
    });
    return ob$;
  }
  getImmigrationCaseTypes() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.IMMIGRATION_CASE_TYPE, undefined)
    ob$.subscribe(resp => {
      this.immigrationCaseTypes = resp.lookupFields;
    });
    return ob$;
  }

  getPTCs() {
    const ob$ = this.userAPI.getEmployeesByRole(RoleType.PTC)
    ob$.subscribe(resp => {
      this.ptcs = resp;
    });
    return ob$;
  }
  getPbStatuses() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.PREBOARDING_STATUS, undefined);
    ob$.subscribe(resp => {
      this.pbStatuses = resp.lookupFields.filter(item => item.id !== StatusTypes.DRAFT && item.id !== StatusTypes.CANCELLED && item.id !== StatusTypes.INVITED);
    });
    return ob$;
  }
  getStartDateStatuses() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.START_DATE_STATUS, undefined);
    ob$.subscribe(resp => {
      this.startDateStatuses = resp.lookupFields;
    });
    return ob$;
  }

  getSSLs() {
    const ob$ = this.lookUpService.getSubServiceLines(undefined, undefined);
    ob$.subscribe(resp => {
      this.subServiceLines = resp;
    });
    return ob$;
  }

  getFilterDates(): DateRange {
    let dr = new DateRange();
    const fp = nullSafe<FilterParams>(() => this.data.sortParameters.filterParams, null);
    if (fp) {
      dr.startDate = fp.startDate;
      dr.endDate = fp.endDate;
    }
    return dr;
  }

  getStartDates() {
    const ob$ = this.pbAPI.getDatesList(DateFields.StartDate, this.getFilterDates());
    ob$.subscribe(resp => {
      this.startDates = resp;
    });
    return ob$;
  }

  getProfileSubmittedDates() {
    const ob$ = this.pbAPI.getDatesList(DateFields.ProfileSubmittedDate, this.getFilterDates());
    ob$.subscribe(resp => {
      this.profileSubmittedDates = resp;
    });
    return ob$;
  }

  getRedirectUrl(candidate: CandidateProfile) {
    if (this.isRecruitment) {
      if (candidate.createdVia == 'IV') {
        this.redirectUrl = "/recruitment/candidate-invite/" + candidate.id;
      } else {
        this.redirectUrl = "/recruitment/candidate-profile/" + candidate.id;
      }

    } else {
      switch (candidate.status.id) {
        case StatusTypes.DRAFT:
          this.redirectUrl = "/pre-boarding/candidate-profile/" + candidate.id;
          break;
        case StatusTypes.PENDING:
          this.redirectUrl = "/pre-boarding/candidate-profile/" + candidate.id;
          break;
        default:
          this.redirectUrl = "/pre-boarding/pb-profile/" + candidate.id;
          break;
      }
    }
    return this.redirectUrl;
  }

  mapBackFilters() {
    if (this.data.sortParameters) {
      this.selectedOfficeLocations = this.officeLocations.filter((obj) => {
        return this.data.sortParameters.filterParams.locationId &&
          this.data.sortParameters.filterParams.locationId.includes(obj.id);
      });
      this.selectedPTCs = this.ptcs.filter((obj) => {
        return this.data.sortParameters.filterParams.ptcId &&
          this.data.sortParameters.filterParams.ptcId.includes(obj.id);
      });
      this.selectedRecruiters = this.recruiters.filter((obj) => {
        return this.data.sortParameters.filterParams.recruiterId &&
          this.data.sortParameters.filterParams.recruiterId.includes(obj.id);
      });
      this.selectedServicelines = this.serviceLines.filter((obj) => {
        return this.data.sortParameters.filterParams.servicLineId &&
          this.data.sortParameters.filterParams.servicLineId.includes(obj.id);
      });
      this.selectedPbStatuses = this.pbStatuses.filter((obj) => {
        return this.data.sortParameters.filterParams.pbStatusIds &&
          this.data.sortParameters.filterParams.pbStatusIds.includes(obj.id);
      });
      this.selectedStartDates = this.startDates.filter((obj) => {
        return this.data.sortParameters.filterParams.startDates &&
          this.data.sortParameters.filterParams.startDates.some((ob) => ob.getTime() === (obj.value.getTime()));
      });
      this.selectedStartDateStatuses = this.startDateStatuses.filter((obj) => {
        return this.data.sortParameters.filterParams.startDateStatuses &&
          this.data.sortParameters.filterParams.startDateStatuses.includes(obj.id);
      });
      this.selectedSSLs = this.subServiceLines.filter((obj) => {
        return this.data.sortParameters.filterParams.subServiceLineIds &&
          this.data.sortParameters.filterParams.subServiceLineIds.includes(obj.id);
      });
      this.selectedProfSubmittedDates = this.profileSubmittedDates.filter((obj) => {
        return this.data.sortParameters.filterParams.profileSubmittedDates &&
          this.data.sortParameters.filterParams.profileSubmittedDates.some((ob) => ob.getTime() === (obj.value.getTime()));
      });
      if (this.data.sortParameters.filterParams.startDate) {
        // tslint:disable-next-line:max-line-length
        this.daterange = this.datePipe.transform(this.data.sortParameters.filterParams.startDate, 'dd-MMM-yy') + " - " + this.datePipe.transform(this.data.sortParameters.filterParams.endDate, 'dd-MMM-yy');
      }

      if (this.data.sortParameters.filterParams.submissionstartDate) {
        // tslint:disable-next-line:max-line-length
        this.submissionDateRange = this.datePipe.transform(this.data.sortParameters.filterParams.submissionstartDate, 'dd-MMM-yy') + " - " + this.datePipe.transform(this.data.sortParameters.filterParams.submissionendDate, 'dd-MMM-yy');

      }
      this.selectedEmployeeCategories = this.employeeCategories.filter((obj) => {
        return this.data.sortParameters.filterParams.employeeCategoryId &&
          this.data.sortParameters.filterParams.employeeCategoryId.includes(obj.id);
      });
      this.selectedPreboardingTypes = this.preboardingTypes.filter((obj) => {
        return this.data.sortParameters.filterParams.pbTypeId &&
          this.data.sortParameters.filterParams.pbTypeId.includes(obj.id);
      });
      this.selectedHireTypes = this.hireTypes.filter((obj) => {
        return this.data.sortParameters.filterParams.hireTypeId &&
          this.data.sortParameters.filterParams.hireTypeId.includes(obj.id);
      });
      this.selectedTransferTypes = this.transferTypes.filter((obj) => {
        return this.data.sortParameters.filterParams.transferTypeID &&
          this.data.sortParameters.filterParams.transferTypeID.includes(obj.id);
      });
      this.selectedImmigrationCaseTypes = this.immigrationCaseTypes.filter((obj) => {
        return this.data.sortParameters.filterParams.immigrationCaseTypeID &&
          this.data.sortParameters.filterParams.immigrationCaseTypeID.includes(obj.id);
      });
    }

  }

  gridConfigure() {

    this.currentPage = this.data.sortParameters ? this.data.sortParameters.page : 1;
    this.totalRecords = this.data.sortParameters ? this.data.sortParameters.totalRecords : 0;
    this.numberOfPages();
    this.pageGenerate();

    if (!isNullOrUndefined(this.data.candidateProfiles)) {
      if (this.data.candidateProfiles.length) {
        this.tableLoading = false;
      } else {
        this.tableLoading = null;
      }
    }
    this.mapBackFilters();
  }

  clear() {
    this.data.sortParameters.filterParams.servicLineId = null;
    this.data.sortParameters.filterParams.locationId = null;
    this.data.sortParameters.filterParams.employeeCategoryId = null;
    this.data.sortParameters.filterParams.pbTypeId = null;
    this.data.sortParameters.filterParams.hireTypeId = null;
    this.data.sortParameters.filterParams.transferTypeID = null;
    this.data.sortParameters.filterParams.immigrationCaseTypeID = null;
    this.data.sortParameters.filterParams.recruiterId = null;
    this.data.sortParameters.filterParams.ptcId = null;
    this.data.sortParameters.filterParams.firstName = null;
    this.data.sortParameters.filterParams.lastName = null;
    this.data.sortParameters.filterParams.startDates = null;
    this.data.sortParameters.filterParams.startDateStatuses = null;
    this.data.sortParameters.filterParams.subServiceLineIds = null;
    this.data.sortParameters.filterParams.profileSubmittedDates = null;
    this.data.sortParameters.filterParams.pbStatusIds = null;
    this.data.sortParameters.filterParams.statusId = null;
    this.data.sortParameters.filterParams.startDate = null;
    this.data.sortParameters.filterParams.endDate = null;
    this.data.sortParameters.filterParams.submissionstartDate = null;
    this.data.sortParameters.filterParams.submissionendDate = null;
    this.daterange = null;
    this.submissionDateRange = null;
    this.data.sortParameters.page = 1;

    this.gridConfigure();
    this.filter();
  }

  filter() {

    if (this.disableSearch) {
      return;
    }

    this.data.sortParameters.filterParams.servicLineId = this.selectedServicelines.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.locationId = this.selectedOfficeLocations.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.employeeCategoryId = this.selectedEmployeeCategories.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.pbTypeId = this.selectedPreboardingTypes.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.hireTypeId = this.selectedHireTypes.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.transferTypeID = this.selectedTransferTypes.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.immigrationCaseTypeID = this.selectedImmigrationCaseTypes.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.recruiterId = this.selectedRecruiters.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.ptcId = this.selectedPTCs.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.startDates = this.selectedStartDates.map((obj: any) => obj.value);
    this.data.sortParameters.filterParams.startDateStatuses = this.selectedStartDateStatuses.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.profileSubmittedDates = this.selectedProfSubmittedDates.map((obj: any) => obj.value);
    this.data.sortParameters.filterParams.subServiceLineIds = this.selectedSSLs.map((obj: any) => obj.id);
    this.data.sortParameters.filterParams.pbStatusIds = this.selectedPbStatuses.map((obj: any) => obj.id);

    this.data.sortParameters.filterParams.startDate = getDateAsUTC(this.data.sortParameters.filterParams.startDate);
    this.data.sortParameters.filterParams.endDate = getDateAsUTC(this.data.sortParameters.filterParams.endDate);

    this.data.sortParameters.filterParams.submissionstartDate = getDateAsUTC(this.data.sortParameters.filterParams.submissionstartDate);
    this.data.sortParameters.filterParams.submissionendDate = getDateAsUTC(this.data.sortParameters.filterParams.submissionendDate);

    this.data.sortParameters.filterParams.statusId = null;
    this.data.sortParameters.page = 1;
    this.totalPages = 0;
    this.disableSearch = true;
    this.candidateService.saveFilterParams(this.mod, this.data.sortParameters.filterParams).subscribe(res => {
      this.data.sortParameters.tileRefreshNeeded = true;
      this.reloadData();
    });

  }

  openReportDateModal(content) {
    this.modalService.open(content);
  }

  report(isvendorReport=false) {
    if (this.tableLoading == null) {
      this.toast.warning("No Candidates Exists");
      return;
    }
    let fileName = '';
    if (isvendorReport) {
      fileName = "TMT Vendor report_";
      this.data.sortParameters.filterParams.isVendorReport = isvendorReport;
      this.disableDownloadVendor = true;
    }
    else {
      fileName = "TMT report_";
      this.disableDownload = true;
      this.data.sortParameters.filterParams.isVendorReport = isvendorReport;
    }
    this.data.sortParameters.filterParams.startDate = getDateAsUTC(this.data.sortParameters.filterParams.startDate);
    this.data.sortParameters.filterParams.endDate = getDateAsUTC(this.data.sortParameters.filterParams.endDate);

    this.data.sortParameters.filterParams.submissionstartDate = getDateAsUTC(this.data.sortParameters.filterParams.submissionstartDate);
    this.data.sortParameters.filterParams.submissionendDate = getDateAsUTC(this.data.sortParameters.filterParams.submissionendDate);

    this.csvreportService.downloadreport(this.isRecruitment, this.data.sortParameters.filterParams)
      .pipe(finalize(() => {
        if (isvendorReport) 
          this.disableDownloadVendor = false;
        else
          this.disableDownload = false;
      })).subscribe(resp => {
         fileName = fileName + (this.datePipe.transform(new Date(), 'dd-MMM-yy')) + ".xlsx";
        if ((window.navigator as any).msSaveOrOpenBlob) {
          (window.navigator as any).msSaveBlob(resp, fileName);
        } else {
          const url = window.URL.createObjectURL(resp);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
        this.modalService.dismissAll();
      });

  }


  filterGridConfigure() {

    this.pageNumber = 1;
    this.currentPage = 1;

    this.pages = [];
    for (let i = 0; i < (this.totalPages > 5 ? 5 : this.totalPages); i++) {
      this.pages.push(i);
    }
  }

  numberOfPages() {
    this.totalPages = this.data.sortParameters ?
      Math.ceil(this.data.sortParameters.totalRecords / this.data.sortParameters.itemsPerPage) : 0;

    return this.totalPages;
  }

  pageGenerate() {
    this.pages = [];

    for (let i = 0; i < (this.totalPages > 5 ? 5 : this.totalPages); i++) {
      this.pages.push(i);
    }

    if (this.totalPages <= 5) {
      this.pageNumber = 1;
    } else if (this.currentPage - 4 > 0) {
      this.pageNumber = this.currentPage - 4;
    }
  }



  onSelectChanges() {
    if (this.currentPage > this.numberOfPages()) {
      this.data.sortParameters.page = this.numberOfPages();
    }
    this.data.sortParameters.tileRefreshNeeded = false;
    this.reloadData();
  }

  sort(reverse: boolean, prop: string) {
    this.data.sortParameters.reverse = reverse;
    this.data.sortParameters.sortBy = prop;
    this.data.sortParameters.tileRefreshNeeded = false;
    this.loader.show();
    this.reloadData();
  }

  pageChange(page: number) {

    if (page > this.totalPages || page <= 0) {
      this.pageNumber = page > this.totalPages ? this.totalPages : 1;
      return;
    }

    if ((page === this.pageNumber + 4) && !((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + 4;
    } else if ((page === this.pageNumber) && (page - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page === this.pageNumber + 4) && ((page + 4) > this.totalPages)) {
      this.pageNumber = this.pageNumber + (this.totalPages - page);
    } else if ((page === this.pageNumber) && (page - 4) < 1) {
      this.pageNumber = 1;
    } else if ((page < this.pageNumber) && (this.pageNumber - 4) > 0) {
      this.pageNumber = this.pageNumber - 4;
    } else if ((page > this.pageNumber + 4) && (page + 4) <= this.totalPages) {
      this.pageNumber = page;
    } else if ((page > this.pageNumber + 4) && (page + 4) > this.totalPages) {
      this.pageNumber = page - ((page + 4) - this.totalPages);
    }

    if (page === 1) {
      this.pageNumber = 1;
    }

    this.data.sortParameters.page = page;
    this.currentPage = this.data.sortParameters.page;
    this.data.sortParameters.tileRefreshNeeded = false;
    this.reloadData();
  }

  editCandidate(candidate: CandidateProfile) {
    this.editEvent.emit(candidate);
  }

  deleteCandidate(candidate: CandidateProfile) {
    this.deleteEvent.emit(candidate);
  }

  editTask(candidate: CandidateProfile) {
    this.editOnTask.emit(candidate);
  }
  getStatusClassName(statusId: number) {
    switch (statusId) {
      case StatusTypes.REJECTED:
        return 'Rejected';
      case StatusTypes.INPROCESS:
        return 'inprogress';
      case StatusTypes.PENDING:
        return 'Pending';
      case StatusTypes.JOINED:
        return 'Joined';
      case StatusTypes.WITHDRAWN:
        return 'Withdrawn';
      case StatusTypes.APPROVED:
        return 'Approved';
      case StatusTypes.HOLD:
        return 'Hold';
      case StatusTypes.DECLINED:
        return 'Declined';
      case StatusTypes.DRAFT:
        return 'Draft';
      case StatusTypes.INVITED:
        return 'Invited';
      case StatusTypes.CANCELLEDINVITE:
        return 'InviteCancelled';
    }
  }

  openMod() {
    this.dialog.showDateRangeFilter(this.data.sortParameters.filterParams, (startDate: Date, endDate: Date) => {
      this.data.sortParameters.filterParams.startDate = startDate;
      this.data.sortParameters.filterParams.endDate = endDate;
      // tslint:disable-next-line:max-line-length
      this.daterange = this.datePipe.transform(this.data.sortParameters.filterParams.startDate, 'dd-MMM-yy') + " - " + this.datePipe.transform(this.data.sortParameters.filterParams.endDate, 'dd-MMM-yy');
    });
  }

  openModSubmissionDate() {
    // tslint:disable-next-line: max-line-length
    this.dialog.showDateRangeFilterSubmisionDate(this.data.sortParameters.filterParams, (submissionstartDate: Date, submissionEndDate: Date) => {
      this.data.sortParameters.filterParams.submissionstartDate = submissionstartDate;
      this.data.sortParameters.filterParams.submissionendDate = submissionEndDate;
      // tslint:disable-next-line:max-line-length
      this.submissionDateRange = this.datePipe.transform(this.data.sortParameters.filterParams.submissionstartDate, 'dd-MMM-yy') + " - " + this.datePipe.transform(this.data.sortParameters.filterParams.submissionendDate, 'dd-MMM-yy');
    });
  }



  clearDate() {
    this.daterange = null;
    this.data.sortParameters.filterParams.startDate = null;
    this.data.sortParameters.filterParams.endDate = null;
  }

  clearSubmssionDate() {
    this.submissionDateRange = null;
    this.data.sortParameters.filterParams.submissionstartDate = null;
    this.data.sortParameters.filterParams.submissionendDate = null;
  }


  reloadData(): void {
    this.filterEvent.emit(this.data.sortParameters);
  }

  onValueChange(value: Date): void {
    this.newstartDate = getDateAsUTC(value);
  }

  SaveStartDate(pop: any, cand: CandidateProfile) {
    const confirmedEnddate = this.setCEDOnSD(this.newstartDate, cand);
    var mailnotify: boolean = false;
    if (cand.startDateStatusId===957 && (isNullOrUndefined(cand.startDate) || (cand.startDate.toDateString() !== this.newstartDate.toDateString()))) {
      this.mailConfirmationBox('Confirm mail trigger',
        `Do you want to notify the change in start date via an email?`,
        () => {
          this.saveStdate(pop, cand, true, confirmedEnddate);
        },
        () => {
          this.saveStdate(pop, cand, false, confirmedEnddate);
        })
    }
    else if (isNullOrUndefined(cand.startDate) || (cand.startDate.toDateString() !== this.newstartDate.toDateString())) {
      this.saveStdate(pop, cand, false, confirmedEnddate);
    }
    else{
      pop.close();
    }
  }

  saveStdate(pop: any, cand: CandidateProfile, mailnotify: boolean, confirmedEnddate: Date) {
    this.pbAPI.saveStartdate(cand.pbProfileId, cand.id, this.newstartDate, mailnotify, confirmedEnddate).subscribe(resp => {
      if (resp.statusCode === HttpStatusCode.BadRequest) {
        this.toast.warning(resp.data);
      } else if (resp.statusCode === HttpStatusCode.OK) {
        this.toast.success(resp.data);
        if (cand.employeeCategory.id == 717 && cand.status.id != 2 && cand.status.id != 1078)
          this.pbAPI.getAppConfigValue("StartDateUpdateTabUrl", cand.id).subscribe(
            (resp) => {
              if (resp != "")
                window.open(resp.concat("splink=", btoa(cand.emailID),
                                        "&ol=", btoa(cand.officeLocation.displayText),
                                        "&ud=", btoa(this.newstartDate.toISOString().slice(0, 10))));
            });
      }
      pop.close();
      // this.gridConfigure();
      this.data.sortParameters.tileRefreshNeeded = true;
      this.reloadData();
    });
  }
  setCEDOnSD(startDate: Date, cand: CandidateProfile) {
    if (isNullOrUndefined(cand.contractDuration)
      || cand.contractDuration == 0
      || cand.contractDuration.toString().length === 0
      || isNullOrUndefined(startDate)) {
      return null;
    }
    const duration = +cand.contractDuration;
    const stdate = new Date(startDate);
    const startDateDay = startDate.getDate();
    return this.getConfiremedEndDate(duration, stdate, startDateDay);
  }
  private getConfiremedEndDate(duration: number, stdate: Date, startDateDay: any) {
    return subDays(addMonths(stdate, duration), 1);
  }

  getMilstones(candidateId: number) {
    const dialogControl = this.dialog.loadPbMilestones()
    this.milestoneAPI.getCandidateMilestones(candidateId).subscribe(resp => {
      dialogControl.componentInstance.milestones = resp;
    })
  }

  mailConfirmationBox(header: string, content: string, onOk: Function, onCancel?: Function) {

    const alertRef = this.modalService.open(AlertComponent, { windowClass: 'custom-class' });
    alertRef.componentInstance.header = header;
    alertRef.componentInstance.content = content;

    alertRef.result.then(resp => {
      if (resp && onOk) {
        onOk();
      } else {
        if (onCancel) {
          onCancel();
        }
      }
    }, dismiss => {
      if (onCancel) {
        onCancel();
      }
    });
  }

  openTimelineReportMod() {
    this.dialog.showTimelineReportBox(true);
  }

   

}
